import { render, staticRenderFns } from "./CCRCertification.vue?vue&type=template&id=35b66ff9&"
import script from "./CCRCertification.vue?vue&type=script&lang=js&"
export * from "./CCRCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports